var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('line-chart',_vm._b({attrs:{"id":"chart2"}},'line-chart',_vm.lineChartProps,false)),_c('line-chart',_vm._b({attrs:{"legend":"true"}},'line-chart',_vm.lineChartProps2,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }